module.exports = __webpack_public_path__ + "static/img/mum-mum.c396f4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/picture_show/mum-mum.jpg
// module id = h6zA
// module chunks = 1